import { Stack } from '@mui/material';
import FromAndToDatePicker from '../../../../../components/mui/FromAndToDatePicker';
// import GlobalSelectFieldWithoutFormikNew from '../../../../../components/mui/GlobalSelectFieldWithoutFormikNew';
// import { useSelector } from 'react-redux';

export default function ProjectAnalyticsFilter({ filter, setFilter }) {
  // const allProjects = useSelector((state) => state.general.allprojects);

  const handleChange = (obj) => {
    setFilter((prev) => ({ ...prev, ...obj }));
  };

  return (
    <Stack direction={'row'} alignSelf={'flex-end'} gap={1}>
      <FromAndToDatePicker
        fromDate={filter?.fromDate}
        toDate={filter?.toDate}
        setFromDate={(f) => {
          handleChange({ fromDate: f });
        }}
        setToDate={(t) => {
          handleChange({ toDate: t });
        }}
      />
      {/*       <GlobalSelectFieldWithoutFormikNew
        label={'Project'}
        data={[{ id: -1, name: 'All' }, ...(allProjects?.projects ?? [])]}
        sx={{ minWidth: 200 }}
        keys={{
          itemId: 'id',
          itemValue: 'name',
        }}
        setDirectChange={(obj) => handleChange({ project: obj })}
        selectedDetails={filter?.project}
      /> */}
    </Stack>
  );
}
